import * as React from "react";
const BackFilledIconSvg = (props) => (
  <svg
    width={54}
    height={30}
    viewBox="0 0 54 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M52 17C53.1046 17 54 16.1046 54 15C54 13.8954 53.1046 13 52 13V17ZM0.585786 13.5858C-0.195262 14.3668 -0.195262 15.6332 0.585786 16.4142L13.3137 29.1421C14.0948 29.9232 15.3611 29.9232 16.1421 29.1421C16.9232 28.3611 16.9232 27.0948 16.1421 26.3137L4.82843 15L16.1421 3.68629C16.9232 2.90524 16.9232 1.63891 16.1421 0.857864C15.3611 0.0768156 14.0948 0.0768156 13.3137 0.857864L0.585786 13.5858ZM52 13H2V17H52V13Z"
      fill="black"
    />
  </svg>
);
export default BackFilledIconSvg;
